import { IconEllipsisHLight } from '@smartbear/swagger-portal-component-library'
import { clsx } from 'clsx'

export interface BreadcrumbEllipsisProps {
  onClick?: () => void;
}

export const BreadcrumbEllipsis = ({
  onClick
}: BreadcrumbEllipsisProps) => (
  <li
    className={clsx(
      'last:after:content-none align-middle flex items-center text-body2 text-(--sp-color-link) hover:text-(--sp-color-link-hover)',
      "after:content-['/'] after:text-(--sp-breadcrumb-separator-color,var(--neutral-80)) dark:after:text-(--sp-breadcrumb-separator-color,var(--neutral-30)) md:after:mx-2 after:mx-1.5",
    )}

  >
    <span
      className="inline-block w-6 h-6 p-1 -m-1 text-center rounded cursor-pointer xl:m-0 xl:w-4 xl:h-4 xl:p-0 hover:bg-(--sp-color-surface-hover)"
      onClick={onClick}>
      <IconEllipsisHLight width={16} height={16} />
    </span>
  </li>
)